import React from 'react';
import './MaintenancePage.css';

const MaintenancePage = () => {
    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <h1>網站維護中</h1>
                <p>我們正在進行系統維護，請稍後再試。</p>
                <p>感謝您的耐心等候。</p>
            </div>
        </div>
    );
};

export default MaintenancePage;
